import { Box, Grid, styled, Typography } from '@mui/material'
import { useRouter } from 'next/router'

import { Address } from '@ecm/data/Address'
import { parseToLeadAddressInfo } from '@ecm/data/LeadAddressInfo'
import EmailOnlyLeadForm from '@ecm/ui/component/form/EmailOnlyLeadForm'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'

const logoSize = {
  dhl: {
    height: 29,
    width: 85,
  },
  fedex: {
    height: 29,
    width: 74,
  },
  ups: {
    height: 34,
    width: 42,
  },
  usps: {
    height: 28,
    width: 45,
  },
}

type AddressCardProps = {
  address: Address
  className?: string
}

const AddressCardColumn = styled(({ address, className }: AddressCardProps) => {
  const { carriers, city, stateAbbreviation } = address

  const router = useRouter()

  const selectAddress = (a: Address) => {
    router
      .push({
        pathname: '/pricing',
        query: { address: a.slug },
      })
      .then(() => {
        window.scrollTo(0, 0)
      })
  }

  return (
    <Box
      margin="1em 0"
      padding="1.5em"
      bgcolor={Color.white.normal}
      border={`1px solid ${Color.smoke.darker}`}
      borderRadius="8px"
      className={className}
    >
      <Typography variant="overline" letterSpacing="0.25em" fontWeight={600}>
        {`${city}, ${stateAbbreviation}`.toUpperCase()}
      </Typography>
      <Typography variant="h5" component="h3" margin="0.25em 0 1em">
        {address.street1}
      </Typography>

      <Typography variant="p3" fontWeight={700}>
        Carriers:
      </Typography>

      <Grid container margin="0 0 2em" alignItems="center">
        {carriers.map(carrier => (
          <Grid item key={carrier} padding="0 0.5em 0 0">
            <CloudflareImage src={`/images/logo/${carrier}.svg`} {...logoSize[carrier]} />
          </Grid>
        ))}
      </Grid>

      <EmailOnlyLeadForm
        onSuccess={() => selectAddress(address)}
        source="Address Sign Up Form"
        leadAddressInfo={parseToLeadAddressInfo(address)}
      />
    </Box>
  )
})({
  '.city': {
    fontSize: '13px',
    fontWeight: 600,
    letterSpacing: '0.25em',
  },
})

export default AddressCardColumn
